import Icon from '../components/Icon.vue'

Icon.register({
  train: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 96v256c0 51.8-61.6 96-130 96l63 49.7c5.9 4.7 2.6 14.3-5 14.3h-304c-7.6 0-10.9-9.6-5-14.3l63-49.7c-68.2 0-130-44-130-96v-256c0-53 64-96 128-96h192c65 0 128 43 128 96zM400 232v-112c0-13.3-10.7-24-24-24h-304c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24zM224 296c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/train.js
// module id = 2025
// module chunks = 0